/**
 * @generated SignedSource<<ecee5cb68219750c899a663dd271634b>>
 * @relayHash 611f36fd3ab140915814f503f8503110
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8

import type { ConcreteRequest } from 'relay-runtime';
export type DataSecurityPolicyAction = "AI_ACCESS" | "ANONYMOUS_ACCESS" | "APP_ACCESS" | "APP_ACCESS_CONFIGURED" | "ATTACHMENT_DOWNLOAD" | "MCP_ACCESS" | "PAGE_EXPORT" | "PUBLIC_LINKS" | "%future added value";
export type DataSecurityPolicyDecidableContentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type graphqlHelpersDSPIsActionEnabledForContentQuery$variables = {
  action: DataSecurityPolicyAction;
  contentId: string;
  contentStatus: DataSecurityPolicyDecidableContentStatus;
  contentVersion: number;
  spaceKey?: string | null;
};
export type graphqlHelpersDSPIsActionEnabledForContentQuery$data = {
  readonly dataSecurityPolicy: {
    readonly isActionEnabledForContent: {
      readonly action: DataSecurityPolicyAction | null;
      readonly allowed: boolean | null;
    };
  } | null;
};
export type graphqlHelpersDSPIsActionEnabledForContentQuery = {
  response: graphqlHelpersDSPIsActionEnabledForContentQuery$data;
  variables: graphqlHelpersDSPIsActionEnabledForContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "action"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentStatus"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentVersion"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "concreteType": "Confluence_dataSecurityPolicy",
    "kind": "LinkedField",
    "name": "dataSecurityPolicy",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "action",
            "variableName": "action"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
          },
          {
            "kind": "Variable",
            "name": "contentVersion",
            "variableName": "contentVersion"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          }
        ],
        "concreteType": "DataSecurityPolicyDecision",
        "kind": "LinkedField",
        "name": "isActionEnabledForContent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "action"
          },
          {
            "kind": "ScalarField",
            "name": "allowed"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "611f36fd3ab140915814f503f8503110",
    "id": "97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8",
    "metadata": {},
    "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
    "operationKind": "query",
    "text": "query graphqlHelpersDSPIsActionEnabledForContentQuery($action:DataSecurityPolicyAction!,$contentId:ID!,$contentStatus:DataSecurityPolicyDecidableContentStatus!,$contentVersion:Int!,$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action,contentId:$contentId,contentStatus:$contentStatus,contentVersion:$contentVersion,spaceKey:$spaceKey){action,allowed}}}"
  }
};
})();

(node as any).hash = "c488c053b9896d7e6d5b6c4474dd396b";

export default node;
